
<div #windowBody class="cnt-column" style="align-items:center; height: 100%; width: 100%;" attr.data-testid="{{testId}}">
    <div *ngIf="showClose" class="cnt-column" style="width: 100%;">
            <div class="cnt-row" style="align-items:center; justify-content:flex-end; height: 30px">
                <div class="close-img closeCls" (click)="onClose()" attr.data-testid="{{testId}}-window-close-btn"></div>
            </div>
    </div>
    <div *ngIf="showClose || title" [style.height.px]="topMargin">
        &nbsp;
    </div>
    <div *ngIf="title"><div class="b1Color h1Font title">{{title | translate}}</div>
    </div>

    <div #body ></div>
</div>
 
